/**
 * Quem pode gerir salas de reunião — uma só regra, para o cartão das Definições,
 * a rota, o atalho do calendário e o ecrã de gestão não terem cada um a sua cópia.
 *
 * É o que o servidor exige ao gravar (`calendar_events.CREATE`, ou administrador):
 * mostrar o ecrã a quem depois leva 403 era enganar. Ser de Recursos Humanos
 * (`users.READ`) não chega.
 */

const ROOMS_ENTITY = "calendar_events";
const ROOMS_ACTION = "CREATE";

/** Para quem já tem `isAdmin` e um `can(entidade, ação)` (contexto de permissões, cartões das Definições). */
export const canManageRooms = (isAdmin: boolean, can: (entity: string, action: string) => boolean): boolean => isAdmin || can(ROOMS_ENTITY, ROOMS_ACTION);

/** Para o guarda de rotas, que recebe o utilizador autenticado. */
export const canManageRoomsUser = (user: { isSuperuser?: boolean; departments?: Array<{ name: string }>; permissions: Array<{ entity: string; actions: string[] }> }): boolean =>
  !!user.isSuperuser || !!user.departments?.some((d) => d.name === "Admin") || user.permissions.some((p) => p.entity === ROOMS_ENTITY && p.actions.includes(ROOMS_ACTION));
